const AuthorCard = () => (
  <div className="flex items-start gap-5 p-6 rounded-xl border border-border bg-card">
    <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-border shrink-0 bg-muted flex items-center justify-center">
      <span className="text-2xl font-heading font-bold text-muted-foreground">A</span>
    </div>
    <div className="flex-1 min-w-0">
      <p className="font-heading font-bold text-foreground text-sm">Auteur</p>
      <p className="text-xs text-muted-foreground mt-0.5">Rédacteur — Votre Entreprise</p>
      <p className="text-xs text-muted-foreground mt-2 leading-relaxed">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore.
      </p>
    </div>
  </div>
);

export default AuthorCard;
